var _defs, _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessages01 = function SvgMessages01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.03,
    y1: 154.2,
    x2: 169.03,
    y2: 24.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 45.87,
    y1: 167.63,
    x2: 181.87,
    y2: 37.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 33.52,
    y1: 154.72,
    x2: 169.52,
    y2: 24.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 20.79,
    y1: 141.39,
    x2: 156.79,
    y2: 11.39,
    gradientTransform: "translate(90.9 -12.39) rotate(45)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 29.04,
    y1: 150.02,
    x2: 165.04,
    y2: 20.02,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M147.47,42.93H25.8c-14.23.04-25.76,11.57-25.8,25.8v102.53c.04,6.87,5.6,12.43,12.47,12.47h0c2.71.02,5.35-.85,7.53-2.46l22.87-17.27c.93-.69,2.05-1.07,3.2-1.07h101.47c14.26-.04,25.8-11.61,25.8-25.87v-68.33c-.04-14.26-11.61-25.8-25.87-25.8ZM159.99,137.08c0,6.92-5.61,12.53-12.53,12.53H46.06c-4.04.02-7.96,1.32-11.2,3.73l-21.53,16.27v-100.87c.04-6.87,5.6-12.43,12.47-12.47h121.72c6.87.05,12.43,5.61,12.47,12.48v68.33Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 112.93,
    cy: 103.53,
    r: 6.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 87.07,
    cy: 103.53,
    r: 6.67
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 60.4,
    cy: 103.53,
    r: 6.67,
    transform: "translate(-55.52 73.03) rotate(-45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.2,16.26H40c-3.69,0-6.67,2.98-6.67,6.67s2.99,6.67,6.67,6.67h134.19c6.87.04,12.43,5.6,12.47,12.47v67.53c0,3.69,2.99,6.67,6.67,6.67h0c3.69-.01,6.67-3,6.67-6.68V42.06c-.04-14.23-11.57-25.76-25.8-25.8Z"
  })));
};
export default SvgMessages01;